import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Properties = _resolveComponent("Properties")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Properties, {
      location: _ctx.location,
      model: _ctx.model,
      subModel: _ctx.subModel,
      locationProperties: _ctx.locationProperties != null ? _ctx.locationProperties.filter(_ctx.selectViewLocation) : null,
      propertyIcons: _ctx.propertyIcons,
      showIconMenu: true
    }, null, 8, ["location", "model", "subModel", "locationProperties", "propertyIcons"])
  ]))
}